import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const BASE_URL = " https://quatdashboard.com:8084";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

  .pv-root {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #f0f2f5;
    min-height: 100vh;
    color: #111827;
  }

  /* ── TOP BAR ── */
  .pv-topbar {
    background: #1e3a5f;
    padding: 0 2rem;
    height: 62px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }

  .pv-brand { display: flex; align-items: center; gap: 12px; }

  .pv-brand-logo {
    width: 38px; height: 38px;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
    color: #fff;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: -0.5px;
    flex-shrink: 0;
  }

  .pv-brand-name { font-size: 1rem; font-weight: 700; color: #ffffff; letter-spacing: -0.01em; }
  .pv-brand-tag  { font-size: 0.68rem; color: rgba(255,255,255,0.5); font-weight: 500; margin-top: 1px; }

  .pv-topbar-right { display: flex; align-items: center; gap: 12px; }

  .pv-search {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 8px;
    padding: 7px 14px;
    font-size: 0.82rem;
    color: #ffffff;
    width: 240px;
    outline: none;
    transition: background 0.15s, border-color 0.15s;
  }
  .pv-search:focus { background: rgba(255,255,255,0.18); border-color: rgba(255,255,255,0.4); }
  .pv-search::placeholder { color: rgba(255,255,255,0.4); }

  .pv-live-chip {
    display: flex; align-items: center; gap: 6px;
    background: rgba(16,185,129,0.15);
    border: 1px solid rgba(16,185,129,0.35);
    border-radius: 20px;
    padding: 5px 13px;
    font-size: 0.7rem; font-weight: 700;
    color: #6ee7b7;
    letter-spacing: 0.08em; text-transform: uppercase;
  }
  .pv-live-dot {
    width: 6px; height: 6px; border-radius: 50%;
    background: #10b981;
    animation: blink 2s ease-in-out infinite;
  }
  @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.25} }

  /* ── BODY ── */
  .pv-body { padding: 1.75rem 2rem 3rem; }

  .pv-section-title {
    font-size: 0.67rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: #9ca3af; margin-bottom: 0.85rem;
  }

  /* ── CARDS GRID ── */
  .pv-cards-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
    margin-bottom: 14px;
  }
  .pv-cards-grid-b {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
    margin-bottom: 1.75rem;
  }

  .pv-card {
    border-radius: 12px;
    padding: 1.1rem 1.25rem;
    display: flex; flex-direction: column; gap: 5px;
    position: relative;
    overflow: hidden;
  }

  /* Card color themes */
  .pv-card.c-blue   { background: #dbeafe; border: 1px solid #bfdbfe; }
  .pv-card.c-green  { background: #d1fae5; border: 1px solid #a7f3d0; }
  .pv-card.c-purple { background: #ede9fe; border: 1px solid #ddd6fe; }
  .pv-card.c-indigo { background: #e0e7ff; border: 1px solid #c7d2fe; }
  .pv-card.c-sky    { background: #e0f2fe; border: 1px solid #bae6fd; }
  .pv-card.c-teal   { background: #ccfbf1; border: 1px solid #99f6e4; }
  .pv-card.c-amber  { background: #fef3c7; border: 1px solid #fde68a; }
  .pv-card.c-rose   { background: #ffe4e6; border: 1px solid #fecdd3; }
  .pv-card.c-orange { background: #ffedd5; border: 1px solid #fed7aa; }
  .pv-card.c-slate  { background: #f1f5f9; border: 1px solid #e2e8f0; }

  .pv-card-label {
    font-size: 0.67rem; font-weight: 700;
    text-transform: uppercase; letter-spacing: 0.1em;
    color: #64748b;
  }

  .pv-card-val {
    font-family: 'JetBrains Mono', monospace;
    font-size: 1.4rem; font-weight: 500;
    letter-spacing: -0.02em; line-height: 1.1;
  }
  .pv-card-val.pos { color: #059669; }
  .pv-card-val.neg { color: #dc2626; }
  .pv-card-val.ink { color: #1e3a5f; }

  .pv-card-sub {
    font-size: 0.63rem; color: #94a3b8; font-weight: 500; margin-top: 1px;
  }

  .pv-beat {
    display: inline-flex; align-items: center; gap: 4px;
    font-size: 0.64rem; font-weight: 700;
    padding: 2px 8px; border-radius: 4px;
    margin-top: 3px; width: fit-content;
  }
  .pv-beat.pos { background: #d1fae5; color: #065f46; border: 1px solid #6ee7b7; }
  .pv-beat.neg { background: #fee2e2; color: #991b1b; border: 1px solid #fca5a5; }

  .pv-setup-rows { display: flex; flex-direction: column; gap: 5px; margin-top: 4px; }
  .pv-setup-row  { display: flex; justify-content: space-between; align-items: center; font-size: 0.75rem; }
  .pv-setup-k    { color: #475569; font-weight: 600; }
  .pv-setup-v    { font-family: 'JetBrains Mono', monospace; font-weight: 500; font-size: 0.78rem; }

  /* ── BANNER ── */
  .pv-banner {
    display: flex; align-items: flex-start; gap: 12px;
    background: #fffbeb; border: 1px solid #fde68a;
    border-left: 3px solid #f59e0b; border-radius: 8px;
    padding: 0.85rem 1.1rem; margin-bottom: 1.75rem;
    font-size: 0.79rem; color: #78350f; line-height: 1.65;
  }
  .pv-banner strong { color: #92400e; }

  /* ── TABLE ── */
  .pv-tbl-wrap {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden; overflow-x: auto;
  }

  .pv-tbl { width: 100%; border-collapse: collapse; font-size: 0.82rem; min-width: 1100px; }

  .pv-tbl thead tr { background: #1e3a5f; }

  .pv-tbl th {
    padding: 0.8rem 1rem;
    font-size: 0.65rem; font-weight: 700;
    letter-spacing: 0.1em; text-transform: uppercase;
    color: rgba(255,255,255,0.6); text-align: left;
    white-space: nowrap;
    border-right: 1px solid rgba(255,255,255,0.06);
  }
  .pv-tbl th:last-child { border-right: none; }
  .pv-tbl th.sort { cursor: pointer; user-select: none; }
  .pv-tbl th.sort:hover { color: #fff; }

  .pv-tbl tbody tr { border-bottom: 1px solid #f3f4f6; transition: background 0.1s; }
  .pv-tbl tbody tr:hover { background: #f8faff; }
  .pv-tbl tbody tr:last-child { border-bottom: none; }

  .pv-tbl td {
    padding: 0.78rem 1rem; color: #374151;
    white-space: nowrap;
    border-right: 1px solid #f9fafb;
    vertical-align: middle;
  }
  .pv-tbl td:last-child { border-right: none; }

  .pv-sym  { font-weight: 700; font-size: 0.86rem; color: #111827; letter-spacing: 0.02em; }

  .pv-setup-badge {
    display: inline-block;
    background: #e0e7ff; color: #3730a3;
    border: 1px solid #c7d2fe;
    border-radius: 4px; padding: 1px 8px;
    font-size: 0.7rem; font-weight: 700; letter-spacing: 0.05em;
  }

  .pv-mono { font-family: 'JetBrains Mono', monospace; font-size: 0.8rem; color: #374151; }

  .pv-ltp { display: flex; align-items: center; gap: 6px; }
  .pv-ltp-price { font-family: 'JetBrains Mono', monospace; font-size: 0.82rem; color: #111827; font-weight: 500; }
  .pv-ltp-pct { font-size: 0.67rem; font-weight: 700; padding: 1px 5px; border-radius: 3px; }
  .pv-ltp-pct.pos { background: #d1fae5; color: #065f46; }
  .pv-ltp-pct.neg { background: #fee2e2; color: #991b1b; }

  .pv-pnl { display: flex; align-items: center; gap: 6px; }
  .pv-pnl-amt { font-family: 'JetBrains Mono', monospace; font-size: 0.82rem; font-weight: 600; }
  .pv-pnl-amt.pos { color: #059669; }
  .pv-pnl-amt.neg { color: #dc2626; }
  .pv-pnl-amt.neu { color: #6b7280; }
  .pv-pnl-pct { font-size: 0.67rem; color: #9ca3af; font-weight: 500; }

  .pv-status {
    display: inline-flex; align-items: center; gap: 5px;
    font-size: 0.68rem; font-weight: 700;
    letter-spacing: 0.05em; text-transform: uppercase;
    padding: 3px 10px; border-radius: 20px;
  }
  .pv-status.active  { background: #d1fae5; color: #065f46; border: 1px solid #6ee7b7; }
  .pv-status.active::before {
    content: ''; width: 5px; height: 5px; border-radius: 50%;
    background: #10b981; animation: blink 2s ease-in-out infinite;
  }
  .pv-status.exited  { background: #f1f5f9; color: #64748b; border: 1px solid #cbd5e1; }

  .pv-days { font-family: 'JetBrains Mono', monospace; font-size: 0.78rem; color: #94a3b8; }
  .pv-days b { color: #374151; font-weight: 500; }

  .pv-footer {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 2rem; padding-top: 1.25rem;
    border-top: 1px solid #e5e7eb;
    font-size: 0.7rem; color: #9ca3af; font-weight: 500;
  }

  .pv-loader { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; background: #f0f2f5; gap: 16px; }
  .pv-spinner { width: 36px; height: 36px; border: 2px solid #e5e7eb; border-top-color: #1e3a5f; border-radius: 50%; animation: spin 0.75s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .pv-loading-txt { font-size: 0.78rem; color: #9ca3af; font-weight: 600; letter-spacing: 0.1em; text-transform: uppercase; }

  .pv-error { display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; gap: 10px; background: #f0f2f5; }
  .pv-error-txt { font-size: 0.9rem; color: #dc2626; font-weight: 500; }

  @media (max-width: 1200px) {
    .pv-cards-grid, .pv-cards-grid-b { grid-template-columns: repeat(3, 1fr); }
  }
  @media (max-width: 768px) {
    .pv-cards-grid, .pv-cards-grid-b { grid-template-columns: repeat(2, 1fr); }
    .pv-body { padding: 1rem 1rem 2rem; }
    .pv-topbar { padding: 0 1rem; }
    .pv-search { width: 160px; }
  }
`;

const fmt2 = (n) => (n != null ? Number(n).toFixed(2) : "—");
const fmtINR = (n) =>
  n != null ? `₹${Number(n).toLocaleString("en-IN")}` : "—";
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "—");
const fmtPct = (v) =>
  v === null || v === undefined || isNaN(v)
    ? "—"
    : `${v >= 0 ? "+" : ""}${Number(v).toFixed(2)}%`;
const cls = (v) => (v > 0 ? "pos" : v < 0 ? "neg" : "ink");

export default function MomentumPublicView() {
  const { token } = useParams();
  const [data, setData] = useState([]);
  const [setupPerf, setSetupPerf] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [sortAsc, setSortAsc] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [t, p] = await Promise.all([
          axios.get(`${BASE_URL}/api/momentumbucket/public?token=${token}`),
          axios.get(
            `${BASE_URL}/api/momentumbucket/public/setup-performance?token=${token}`,
          ),
        ]);
        setData(t.data);
        setSetupPerf(p.data);
      } catch (e) {
        setError(
          e.response?.status === 403
            ? "Invalid or expired share link."
            : "Failed to load data.",
        );
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const totalPnL = data.reduce((s, i) => s + (i.pnl || 0), 0);
  const totalActive = data.filter((i) => i.status === "active").length;
  const totalExited = data.filter((i) => i.status === "exited").length;
  const totalAlloc = data
    .filter((i) => i.status === "active")
    .reduce((s, i) => s + (i.allocation || 0), 0);
  const baseCapital = 500000;
  const pnlPct = (totalPnL / baseCapital) * 100;

  const firstDate = data.length
    ? new Date(Math.min(...data.map((i) => new Date(i.entry_date).getTime())))
    : null;
  const yearsElapsed = firstDate
    ? (Date.now() - firstDate) / (1000 * 60 * 60 * 24 * 365.25)
    : 0;
  const sinceLabel = firstDate
    ? firstDate.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "—";

  const portfolioCAGR =
    yearsElapsed > 0
      ? (Math.pow(1 + pnlPct / 100, 1 / yearsElapsed) - 1) * 100
      : null;
  const niftyTotalPct =
    data.find((t) => t.stnifty_percent != null)?.stnifty_percent ?? null;
  const niftyCAGR =
    niftyTotalPct !== null && yearsElapsed > 0
      ? (Math.pow(1 + niftyTotalPct / 100, 1 / yearsElapsed) - 1) * 100
      : null;
  const alpha =
    portfolioCAGR !== null && niftyCAGR !== null
      ? portfolioCAGR - niftyCAGR
      : null;
  const niftyChange =
    data.find((t) => t.status === "active" && t.stnifty_percent != null)
      ?.stnifty_percent ?? 0;

  const filtered = data
    .filter(
      (i) =>
        i.symbol?.toLowerCase().includes(search) ||
        i.setup?.toLowerCase().includes(search) ||
        i.status?.toLowerCase().includes(search),
    )
    .sort((a, b) =>
      sortAsc
        ? a.status.localeCompare(b.status)
        : b.status.localeCompare(a.status),
    );

  if (loading)
    return (
      <div className="pv-loader">
        <style>{CSS}</style>
        <div className="pv-spinner" />
        <div className="pv-loading-txt">Loading Portfolio</div>
      </div>
    );

  if (error)
    return (
      <div className="pv-error">
        <style>{CSS}</style>
        <div className="pv-error-txt">{error}</div>
      </div>
    );

  // Card definitions: [label, value, colorClass, valueColorClass, sub]
  const row1 = [
    {
      label: "Total P&L",
      val: fmtINR(totalPnL),
      color: "c-blue",
      vc: cls(totalPnL),
      sub: null,
    },
    {
      label: "Active Trades",
      val: totalActive,
      color: "c-green",
      vc: "ink",
      sub: null,
    },
    {
      label: "Exited Trades",
      val: totalExited,
      color: "c-purple",
      vc: "ink",
      sub: null,
    },
    {
      label: "Active Allocation",
      val: fmtINR(totalAlloc),
      color: "c-indigo",
      vc: "ink",
      sub: null,
    },
    {
      label: "Nifty Change",
      val: fmtPct(niftyChange),
      color: "c-sky",
      vc: cls(niftyChange),
      sub: `Since ${sinceLabel}`,
    },
  ];

  const row2 = [
    {
      label: "P&L Return %",
      val: fmtPct(pnlPct),
      color: "c-teal",
      vc: cls(pnlPct),
      sub: null,
    },
    {
      label: "Portfolio CAGR",
      val: fmtPct(portfolioCAGR),
      color: "c-amber",
      vc: cls(portfolioCAGR ?? 0),
      sub: `Since ${sinceLabel}${yearsElapsed > 0 && yearsElapsed < 1 ? " · Ann." : ""}`,
    },
    {
      label: "Nifty 50 CAGR",
      val: fmtPct(niftyCAGR),
      color: "c-rose",
      vc: cls(niftyCAGR ?? 0),
      sub: `Since ${sinceLabel}`,
    },
  ];

  return (
    <div className="pv-root">
      <style>{CSS}</style>

      {/* ── TOP BAR ── */}
      <div className="pv-topbar">
        <div className="pv-brand">
          <div className="pv-brand-logo">N₅</div>
          <div>
            <div className="pv-brand-name">Nifty 50 Momentum Tracker</div>
            <div className="pv-brand-tag">Read-only client portfolio view</div>
          </div>
        </div>
        <div className="pv-topbar-right">
          <input
            className="pv-search"
            placeholder="Search symbol, setup, status…"
            value={search}
            onChange={(e) => setSearch(e.target.value.toLowerCase())}
          />
          <div className="pv-live-chip">
            <div className="pv-live-dot" />
            Live
          </div>
        </div>
      </div>

      <div className="pv-body">
        {/* ── ROW 1 CARDS ── */}
        <div className="pv-section-title">Portfolio Overview</div>
        <div className="pv-cards-grid">
          {row1.map((c, i) => (
            <div key={i} className={`pv-card ${c.color}`}>
              <div className="pv-card-label">{c.label}</div>
              <div className={`pv-card-val ${c.vc}`}>{c.val}</div>
              {c.sub && <div className="pv-card-sub">{c.sub}</div>}
            </div>
          ))}
        </div>

        {/* ── ROW 2 CARDS ── */}
        <div className="pv-cards-grid-b">
          {row2.map((c, i) => (
            <div key={i} className={`pv-card ${c.color}`}>
              <div className="pv-card-label">{c.label}</div>
              <div className={`pv-card-val ${c.vc}`}>{c.val}</div>
              {c.sub && <div className="pv-card-sub">{c.sub}</div>}
            </div>
          ))}

          {/* Alpha card */}
          <div className="pv-card c-orange">
            <div className="pv-card-label">QUAT vs Nifty 50</div>
            <div className={`pv-card-val ${cls(alpha ?? 0)}`}>
              {fmtPct(alpha)}
            </div>
            {alpha !== null && (
              <div className={`pv-beat ${alpha >= 0 ? "pos" : "neg"}`}>
                {alpha >= 0 ? "▲ Beating benchmark" : "▼ Below benchmark"}
              </div>
            )}
          </div>

          {/* Setup Performance card */}
          <div className="pv-card c-slate">
            <div className="pv-card-label">Setup Performance</div>
            <div className="pv-setup-rows">
              {Object.entries(setupPerf).map(([k, v]) => (
                <div key={k} className="pv-setup-row">
                  <span className="pv-setup-k">{k}</span>
                  <span
                    className={`pv-setup-v`}
                    style={{ color: v >= 0 ? "#059669" : "#dc2626" }}
                  >
                    {fmtPct(v)}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── BENCHMARK BANNER ── */}
        <div className="pv-banner">
          <span style={{ fontSize: "1rem", flexShrink: 0, marginTop: 1 }}>
            📊
          </span>
          <div>
            <strong>Benchmark: Nifty 50 Index</strong> — We invest exclusively
            in Nifty 50 stocks and measure performance against the index. Our
            goal is to consistently generate <strong>QUAT</strong> — returns
            above the benchmark — through disciplined momentum-based stock
            selection.
          </div>
        </div>

        {/* ── TRADE TABLE ── */}
        <div className="pv-section-title">
          Trade Log — {filtered.length} records
        </div>
        <div className="pv-tbl-wrap">
          <table className="pv-tbl">
            <thead>
              <tr>
                {[
                  ["Symbol", ""],
                  ["Setup", ""],
                  ["Entry Price", ""],
                  ["Entry Date", ""],
                  ["LTP", ""],
                  ["SL", ""],
                  ["Target", ""],
                  ["Qty", ""],
                  ["Allocation", ""],
                  ["Exit Price", ""],
                  ["Exit Date", ""],
                  ["Charges", ""],
                  ["P&L", ""],
                  ["Status", "sort"],
                  ["Days", ""],
                ].map(([h, c]) => (
                  <th
                    key={h}
                    className={c}
                    onClick={
                      c === "sort" ? () => setSortAsc(!sortAsc) : undefined
                    }
                  >
                    {h}
                    {c === "sort" ? (sortAsc ? " ↑" : " ↓") : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td
                    colSpan={15}
                    style={{
                      textAlign: "center",
                      padding: "3rem",
                      color: "#9ca3af",
                    }}
                  >
                    No matching records found.
                  </td>
                </tr>
              ) : (
                filtered.map((item, idx) => {
                  const ltpDiff =
                    item.ltp && item.entry_price
                      ? item.ltp - item.entry_price
                      : null;
                  const ltpPct =
                    ltpDiff !== null
                      ? ((ltpDiff / item.entry_price) * 100).toFixed(2)
                      : null;
                  const pnlPctRow =
                    item.pnl && item.allocation
                      ? ((item.pnl / item.allocation) * 100).toFixed(2)
                      : 0;

                  return (
                    <tr key={idx}>
                      <td>
                        <span className="pv-sym">{item.symbol}</span>
                      </td>
                      <td>
                        <span className="pv-setup-badge">{item.setup}</span>
                      </td>
                      <td>
                        <span className="pv-mono">
                          {fmt2(item.entry_price)}
                        </span>
                      </td>
                      <td>
                        <span className="pv-mono">
                          {fmtDate(item.entry_date)}
                        </span>
                      </td>
                      <td>
                        {ltpDiff !== null ? (
                          <div className="pv-ltp">
                            <span className="pv-ltp-price">
                              {fmt2(item.ltp)}
                            </span>
                            <span
                              className={`pv-ltp-pct ${ltpDiff >= 0 ? "pos" : "neg"}`}
                            >
                              {ltpDiff >= 0 ? "▲" : "▼"} {Math.abs(ltpPct)}%
                            </span>
                          </div>
                        ) : (
                          "—"
                        )}
                      </td>
                      <td>
                        <span className="pv-mono">{fmt2(item.sl)}</span>
                      </td>
                      <td>
                        <span className="pv-mono">{fmt2(item.target)}</span>
                      </td>
                      <td>
                        <span className="pv-mono">{item.quantity}</span>
                      </td>
                      <td>
                        <span className="pv-mono">
                          {fmtINR(item.allocation)}
                        </span>
                      </td>
                      <td>
                        <span className="pv-mono">
                          {item.exit_price != null
                            ? fmt2(item.exit_price)
                            : "—"}
                        </span>
                      </td>
                      <td>
                        <span className="pv-mono">
                          {fmtDate(item.exit_date)}
                        </span>
                      </td>
                      <td>
                        <span className="pv-mono">
                          {item.charges != null ? fmt2(item.charges) : "—"}
                        </span>
                      </td>
                      <td>
                        {item.pnl !== null ? (
                          <div className="pv-pnl">
                            <span className={`pv-pnl-amt ${cls(item.pnl)}`}>
                              {fmtINR(item.pnl)}
                            </span>
                            <span className="pv-pnl-pct">
                              {item.pnl > 0 ? "▲" : item.pnl < 0 ? "▼" : ""}{" "}
                              {Math.abs(pnlPctRow)}%
                            </span>
                          </div>
                        ) : (
                          "—"
                        )}
                      </td>
                      <td>
                        <span className={`pv-status ${item.status}`}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <span className="pv-days">
                          <b>{item.days_passed}</b>/{item.max_days}
                        </span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        {/* ── FOOTER ── */}
        <div className="pv-footer">
          <span>Nifty 50 Momentum Portfolio · {new Date().getFullYear()}</span>
          <span>
            Read-only view · For informational purposes only · Not investment
            advice
          </span>
        </div>
      </div>
    </div>
  );
}
